import React, { useEffect } from "react";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import OrderDetailListItem from "./OrderDetailListItem";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrderDetailList } from "../../actions/catalog";
import { formatDate } from "../../utils";
import InfoBox from "../../components/Reusable/InfoBox";
import { t } from "i18next"; // Import t function for translation

const OrderDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { orderDetailList } = useSelector((state) => state.catalogReducer);

  useEffect(() => {
    dispatch(fetchOrderDetailList(id));
  }, [dispatch]);

  const statusName =
    orderDetailList?.status === "PENDING"
      ? t("orderDetail.status.pending")
      : orderDetailList?.status === "APPROVED"
      ? t("orderDetail.status.approved")
      : t("orderDetail.status.rejected");

  return (
    <div className="order-detail-main-container">
      <Breadcrumb
        title={t("orderDetail.breadcrumbTitle")}
        returnPage={"/order"}
      />

      <div className="order-detail-list-container">
        <div className="order-detail-list-type-receipt d-flex flex-column justify-content-beetween align-items-left">
          {orderDetailList?.rejectReason && (
            <InfoBox
              text={`${t("orderDetail.rejectReasonTitle")}: ${
                orderDetailList?.rejectReason
              }`}
            />
          )}
          <div className="order-detail-list-type-receipt-title mt-3">
            {t("orderDetail.receiptNumberTitle")}:{" "}
            <span>{orderDetailList?.receiptNumber}</span>
          </div>
          {orderDetailList?.receiptCopyNumber && (
            <div className="order-detail-list-type-receipt-title mt-1">
              {t("orderDetail.receiptCopyNumberTitle")}:{" "}
              <span>{orderDetailList?.receiptCopyNumber}</span>
            </div>
          )}
          <div className="order-detail-list-type-receipt-title mt-1">
            {t("orderDetail.statusTitle")}: <span>{statusName}</span>
          </div>
          <div className="order-detail-list-type-receipt-title mt-1">
            {t("orderDetail.dateTitle")}:{" "}
            <span>{formatDate(orderDetailList?.dateOnReceipt)}</span>
          </div>
        </div>
        <div className="order-detail-list-type-image">
          {orderDetailList?.receiptImage ? (
            <img
              src={orderDetailList?.receiptImage}
              className="img-fluid"
              alt="Receipt"
            />
          ) : (
            <InfoBox text={t("orderDetail.noImage")} />
          )}
        </div>
        <div className="order-detail-list-items">
          {orderDetailList?.items?.map((item, key) => (
            <OrderDetailListItem key={key} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrderDetail;
